import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class AppIcon extends Component {
  static propTypes = {
    iconCls: PropTypes.string.isRequired,
    ctrCls: PropTypes.string
  }

  static defaultProps = {
    ctrCls: '',
    notSvg: false
  }

  render() {
    const { ctrCls, iconCls } = this.props;
    const useTag = `<use xlink:href='IconsSprite.svg#${iconCls}'/>`;
    return (
      <svg className={`app-icon ${ctrCls}`} dangerouslySetInnerHTML={{__html: useTag }} />
    )
  }
}

export default AppIcon
